<template>
<div class="side animate-box">
    <h1 v-if="id_design == '341'">Contact A Coach</h1>
    <p v-else-if="this.$store.state.companyData['id_company'] == '100679170'"><strong>Contact A Coach</strong><br /><br /><sup><em>By contacting Aetna, you agree that any information you share will be kept confidential and will not be shared with McKesson and that your information will be stored in a secure location, which may be outside your home country.</em></sup></p>
    <h1 v-else v-html="lang_detail['cntr1238']"></h1>

    <div v-if="returnmsg==''">
        <p> <span v-html="lang_detail['requiredDescription']"></span> (<span class="required_indicator">*</span>)</p>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="name" v-html="lang_detail['name']"></label>
                <input type="text" id="name" class="form-control" v-model="name" ref="name" aria-label="Name" aria-required="true" @keypress="isLetterWithSpace($event)">
            </div>
            <span id="name_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="phone" v-html="lang_detail['phone']+lang_detail['phoneformat']"></label>                
                <input type="text" id="phone" class="form-control" v-model="phone" ref="phone" aria-label="Phone" aria-required="true" @keypress="isNumberWithHyphen($event)">
            </div>
            <span id="phone_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="country_list" v-html="lang_detail['country']"></label>
                <select name="country" id="country_list" v-model="country" class="form-control" ref="country" aria-label="Country" aria-required="true">
                    <option value=""></option>
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Angola">Angola</option>
                    <option value="Antarctica">Antarctica</option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Azores">Azores</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Baloush (Iran - Baluchistan Region)">Baloush (Iran - Baluchistan Region)</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia &amp; Herzegovina">Bosnia &amp; Herzegovina</option>
                    <option value="Botswana">Botswana</option>
                    <option value="Brazil">Brazil</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Central African Republic">Central African Republic</option>
                    <option value="Chad">Chad</option>
                    <option value="Channel Islands">Channel Islands</option>
                    <option value="Chile">Chile</option>
                    <option value="China, PR">China, PR</option>
                    <option value="Colombia">Colombia</option>
                    <option value="Congo">Congo</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cote d'Ivoire">Cote d'Ivoire</option>
                    <option value="Croatia">Croatia</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Diego Garcia">Diego Garcia</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominican Republic">Dominican Republic</option>
                    <option value="East Timor">East Timor</option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Faeroe Islands">Faeroe Islands</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Greece">Greece</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Guam">Guam</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-Bissau">Guinea-Bissau</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran">Iran</option>
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kosovo">Kosovo</option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Laos">Laos</option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libya">Libya</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macau">Macau</option>
                    <option value="Macedonia">Macedonia</option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Mali, Republic of">Mali, Republic of</option>
                    <option value="Malta">Malta</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Moldova">Moldova</option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montenegro">Montenegro</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="North Korea">North Korea</option>
                    <option value="Norway">Norway</option>
                    <option value="Okinawa">Okinawa</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palestinian Territories">Palestinian Territories</option>
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Romania">Romania</option>
                    <option value="Russia">Russia</option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra Leone">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Somalia">Somalia</option>
                    <option value="Somaliland">Somaliland</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South Korea">South Korea</option>
                    <option value="Spain">Spain</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="St. Lucia">St. Lucia</option>
                    <option value="St. Maarten">St. Maarten</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syria">Syria</option>
                    <option value="Taiwan">Taiwan</option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania">Tanzania</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Timor-Leste (East Timor)">Timor-Leste (East Timor)</option>
                    <option value="Togo (Togolese Republic)">Togo (Togolese Republic)</option>
                    <option value="Trinidad &amp; Tobago">Trinidad &amp; Tobago</option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Turks &amp; Caicos Islands">Turks &amp; Caicos Islands</option>
                    <option value="UAE">UAE</option>
                    <option value="Uganda">Uganda</option>
                    <option value="UK - England">UK - England</option>
                    <option value="UK - Northern Ireland">UK - Northern Ireland</option>
                    <option value="UK - Scotland">UK - Scotland</option>
                    <option value="UK - Wales">UK - Wales</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="USA">USA</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Vietnam">Vietnam</option>
                    <option value="Virgin Islands - British">Virgin Islands - British</option>
                    <option value="Virgin Islands - US">Virgin Islands - US</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
				</select>
            </div>
            <span id="country_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <label for="emaill" v-html="lang_detail['email']"></label>
                <input type="email" id="emaill" class="form-control" v-model="email" ref='email' aria-label="Email" @keypress="htmlfiveValidationErr($event)" title="enter valid email">
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <label for="bestTime" v-html="lang_detail['phoneTimes']"></label>
                <select name="bestTime" id="bestTime" v-model="best_time" class="form-control" ref="bestTime" aria-label="Best time to call">
                    <option v-html="lang_detail['anytime']" selected></option>
                    <option v-html="lang_detail['morning']"></option>
                    <option v-html="lang_detail['afternoon']"></option>
                    <option v-html="lang_detail['evening']"></option>
                </select>            
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="phoneMsg" v-html="lang_detail['phoneMsg']"></label>
                <select name="phoneMsg" id="phoneMsg" v-model="phoneMsg" class="form-control" ref="phoneMsg" aria-label="Message to phone" aria-required="true">
                    <option v-html="lang_detail['no']" selected></option>
                    <option v-html="lang_detail['yes']"></option>
                </select>
                <span id="phoneMsg_validation_error"  role="alert"></span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <span class="required_indicator">*</span>
                <label for="message" v-html="lang_detail['reason']"></label>
                <textarea id="message" rows="20" cols="20" class="form-control" v-model="message" ref="message" aria-label="reason for inquiry" aria-required="true" maxlength="3000"></textarea>
            </div>
            <span id="message_validation_error"  role="alert"></span>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <input type="checkbox" name="fterms" id="fterms" v-model="fterms" ref="fterms" aria-label="accept terms and conditions" aria-required="true">&nbsp;<span v-html="lang_detail['terms_check']"></span>
            </div>
            <span id="fterms_validation_error" role="alert"></span>
        </div>
        <div class="row form-group">
            <p></p>
        </div>
       <div class="row form-group hhcap">
            <vue-hcaptcha :sitekey="$store.state.HC_SITE_KEY"  @verify="onVerify" @expired="onExpire" @error="onError"></vue-hcaptcha>
            <span id="hccaptcha_validation_error" role="alert"></span>
        </div>
        <div class="form-group">
            <button type="button" :disabled="disablefdbtn" class="btn submit btn-primary" @click="sendForm()" v-html="lang_detail['submit']"></button>
        </div>
    </div>
    <p v-else v-html="returnmsg" role="alert"></p>
</div>    
</template>

<script>
import axios from 'axios';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
export default {
    name: 'ContactCoach',
    data(){
        return{
            lang_detail:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            FORM_ACTION_DOMAIN:this.$store.state.FORM_ACTION_DOMAIN,
            languageData:this.$store.state.languageData,
            fterms:'',message:'',email:'',name:'',returnmsg:'',        
            phone:'',
            country:'',
            best_time:'',
            id_design:localStorage.id_design,
            phoneMsg:'',
            verified: false,
            expired: false,
            token: null,
            eKey: null,
            error: null,
            disablefdbtn:false
        };
        
    },
    components:{
        VueHcaptcha       
    },
    mounted :function(){
        this.getlangVar()
    },
    created:function(){
    },
    watch: {
        name: function() {
            this.validateFormRemoveMarkers('name_validation_error');               
        },
        phone: function() {
            this.validateFormRemoveMarkers('phone_validation_error');               
        },        
        country: function() {
            this.validateFormRemoveMarkers('country_validation_error');               
        },        
        message: function() {
            this.validateFormRemoveMarkers('message_validation_error');               
        },        
        fterms: function() {
            this.validateFormRemoveMarkers('fterms_validation_error');               
        },
        phoneMsg: function(){
            this.validateFormRemoveMarkers('phoneMsg_validation_error');
        },
        verified: function() {
            this.validateFormRemoveMarkers('hccaptcha_validation_error');               
        }
    },
	methods:{
        sendForm(){            
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'                   
                }
            }

            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('phone', this.phone)
            formData.append('email', this.email)
            formData.append('country', this.country)
            formData.append('bestTime', this.best_time)
            formData.append('message', this.message)
            formData.append('terms', this.fterms)
            formData.append('id_company', this.$store.state.companyData['id_company'])
            formData.append('id_language', this.$store.state.companyData['id_language'])
            formData.append('name_company', this.$store.state.companyData['name_company'])
            formData.append('id_eap', this.$store.state.companyData['id_eap'])
            formData.append('id_country', this.$store.state.companyData['id_country'])
            formData.append('phoneMsg',this.phoneMsg)
            formData.append('hc_token', this.token)
            
           var validateForm = this.validateForm(this.name,this.phone,undefined,this.country,undefined,undefined,this.message,undefined,this.fterms,this.phoneMsg,undefined,undefined,undefined,undefined,undefined,undefined,undefined,this.verified);           
           if(!validateForm){  
                this.disablefdbtn=true;                     
                axios.post(this.$store.state.FORM_ACTION_DOMAIN+'/new_eesite_forms/contact_coach_form.php',formData,config)
                .then(response => {
                    if(response === undefined || response.length == 0 ){
                        this.returnmsg='! Something went wrong, Please try again'
                    }
                    else{
                        this.returnmsg = response.data                        
                    }                    
                })
                .catch(() => {                    
                    this.returnmsg='Try after sometime'
                });
            }
        },
        getlangVar(){
            var api_private_key=this.get_api_key_mix('lams')
            axios.get(this.$store.state.apiUrl+'/language_terms',{
                params:{
                    id_language:this.$store.state.companyData['id_language'],
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country']                  
                }
            })
            .then(response => {              
                response = response.data;                  
                this.lang_detail = response;
                if(this.id_design == '341'){
                    var titleValue ="Contact A Coach";
                }  
                else{
                    var titleValue =this.lang_detail['cntr1238'];
                }

                var home = this.lang_detail['d00'];
                this.$announcer.set(this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company']);
                document.title = this.decodeHtmlLang(titleValue)+' | '+this.$store.state.companyData['name_company'];                
            })
            .catch(() => {
                this.main_content = []
            });
        },
        onVerify(token, ekey) {
            this.verified = true;
            this.token = token;
            this.eKey = ekey;
        },
        onExpire() {
            this.verified = false;
            this.token = null;
            this.eKey = null;
            this.expired = true;
            //console.log('hcExpired');
        },
        onError(err) {
            this.token = null;
            this.eKey = null;
            this.error = err;
            //console.log(`hcError: ${err}`);
        }
    }
};
</script>
<style scoped>
.form-group{
    margin-bottom: 40px;
}
.side{
   margin-left:15px; 
}
.side .submit{
    right: 20px !important;
}
@media screen and (max-width: 350px) {
    .side{
        margin-left:18px; 
    }
    .side .submit{
        right: 30px !important;
    }
}
.dynamic_form_error_required{
    padding-left:15px !important;
    color:#FF0000 !important;    
}
.required_indicator {
    font-family: Verdana;
    font-size: 14px;
    color: red;
}
.form-control {
    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;
}
.hhcap{
    padding-left: 1em;
}
</style>